import { useSelector } from 'react-redux';
import { SupportedChainId } from '@orionprotocol/sdk';
import { z } from 'zod';
import { chainInfoSchema } from '@orionprotocol/common';

import { getChains } from '../../redux/selectors';

export function useChains(): Partial<
  Record<SupportedChainId, z.infer<typeof chainInfoSchema>>
> {
  const chains = useSelector(getChains);

  return chains;
}
